// extracted by mini-css-extract-plugin
export default {"free":"free__YFkHv","freeImg":"freeImg__25y47"};